
import { useEffect } from "react";
import { Annotation, FilePath, IAnnotationData } from "../../../types";
import { AnnotationHandler } from "../../annotations/AnnotationHandler";
import { createGlyphNumber } from "../../annotations/AnnotationTypes";
import { DoublyLinkedList } from "../linked-list/DoublyLinkedList";

interface AnnotationsProps {
  walkthroughSteps?: DoublyLinkedList<Annotation>;
  annotationHandler?: AnnotationHandler;
}

export const useAnnotations = ({ walkthroughSteps, annotationHandler }: AnnotationsProps) => {

  useEffect(() => {
    if (annotationHandler && walkthroughSteps) {
      const annotationSteps: { [filePath: FilePath]: IAnnotationData[] } = {};

      walkthroughSteps.forEach((step) => {
        if (step.value.startLineNumber && step.value.filePath) {
          annotationSteps[step.value.filePath] = [
            ...(annotationSteps[step.value.filePath] || []),
            createGlyphNumber(step.value.index, step.value.startLineNumber, step.value.title),
          ];
        }
      });

      const annotationIds: string[] = [];
      Object.entries(annotationSteps).forEach(([filePath, annotation]) => {
        const ids = annotationHandler!.addAnnotations(filePath, annotation);
        annotationIds.push(...ids);
      });

      return () => {
        annotationHandler?.removeAnnotations(annotationIds);
      }
    }
    return;
  }, [annotationHandler, walkthroughSteps])
}